import React from 'react';
import { ApolloClient } from '@apollo/client';
import gql from 'graphql-tag';
import { useRootStore } from 'store';

import { useApolloClient } from '@apollo/client';

export enum UserPermission {
  None = 0,
  ViewOnly = 1,
  Full = 2,
  InsertOnly = 3,
  InsertUpdateOnly = 4,
}

// Αντιστοίχιση Delphi Menu με Web (USR_PARAMS_VALUES)
const paramsDictionary = {
  Users: 'TdbUsersFrm',
  Gates: 'TdbGatesFrm',
  Workers: 'TdbWorkersFrm',
  Vehicles: 'TdbVehiclesFrm',
  Containers: 'TdbContainersFrm',
  BinTypes: 'TdbBinTypesFrm',
  MaterialTypes: 'TdbMaterialTypesFrm',
  Customers: 'TdbCustomersFrm',
  WbDeliveries: 'TwbDelivFrm',
  WbDispatches: 'TwbDispFrm',
  WbProductions: 'TwbProdFrm',
  WbPressProductions: 'TwbPressProductionFrm',
  DeliveriesReport: 'TrepDelivFrm',
  DispatchesReport: 'TrepDispFrm',
  ProductionsReport: 'TrepProdFrm',
  DeliveriesAnalysis: 'TDgrmDeliveriesFrm',
  DispatchesAnalysis: 'TDgrmDispatchesFrm',
  ProductionsAnalysis: 'TDgrmProductionFrm',
};

const UserUsrParamsValuesDocument = gql`
  query getUserUsrParamsValues {
    getUserUsrParamsValues {
      data {
        id
        paramName
        intValue
      }
      recordCount
    }
  }
`;

function getUserUsrParamsValuesPromise(client: ApolloClient<object>): Promise<any> {
  return new Promise((resolve, reject) => {
    client
      .query<any, any>({
        query: UserUsrParamsValuesDocument,
        variables: {},
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        if (res.data.getUserUsrParamsValues !== null) {
          resolve(res.data.getUserUsrParamsValues);
        } else {
          reject(res.errors[0].message);
        }
      })
      .catch((err) => reject(err));
  });
}

export const useUserPermissions = () => {
  const client = useApolloClient();
  const { appStore, authStore } = useRootStore();

  const getUserUsrParamsValues = async () => {
    const usr_params = await getUserUsrParamsValuesPromise(client);
    // console.log('$$$ params = ', usr_params);
    return usr_params.data;
  };

  const getMenuItemPermissions = (menuItem: string) => {
    return 2; // Full Permissions

    if (!appStore.userParams) return false;
    if (!Array.isArray(appStore.userParams)) return false;

    const paramName = paramsDictionary[menuItem];
    const paramRec = appStore.userParams.find((element) => element.paramName === paramName);

    return paramRec ? paramRec.intValue : false;
  };

  const getUserCanView = (menuItem: string) => {
    const permissions = getMenuItemPermissions(menuItem);

    if (permissions && permissions !== UserPermission.None) return true;
    else return false;
  };

  return { getUserUsrParamsValues, getMenuItemPermissions, getUserCanView };
};

